<template>
    <UApp>
        <div
            class="mx-auto min-h-full w-full max-w-7xl bg-[#FFFCF5] px-5 xl:px-0"
        >
            <AppHeader />

            <AppHelp />

            <main>
                <NuxtPage />
            </main>

            <ClientOnly>
                <CookieBanner />
            </ClientOnly>
        </div>
    </UApp>
</template>

<script setup lang="ts">
useHead({
    titleTemplate: "%s",
})

const { serverUri } = useDataLogic()

const store = useMainStore()

onMounted(async () => {
    CreateHesloAll()
})

async function CreateHesloAll() {
    const data = await $fetch<any[]>("select-heslo-all", {
        baseURL: serverUri(),
    })
    store.streetsAll = data
}

function checkIfMobileWidth() {
    if (windowWidth.value <= 768) {
        store.mobileMode = true
    } else {
        store.mobileMode = false
    }
}

const { width: windowWidth } = useWindowSize({ type: "visual" })

watchThrottled(windowWidth, checkIfMobileWidth, { throttle: 200 })

onMounted(() => {
    checkIfMobileWidth()
})
</script>
